"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/web.dom.iterable");
var _util = require("@/utils/util");
var _delivery = require("@/api/doc/delivery");
var _validate = require("@/utils/validate");
var _utils = require("@/utils");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'deliveryInfo',
  data: function data() {
    return {
      loading: null,
      isCnLang: false,
      form: {
        blNo: ''
      },
      rules: {
        blNo: [{
          required: true,
          message: this.$t('validate.blNo'),
          trigger: 'blur'
        }]
      },
      isResult: false,
      baseData: {
        blNo: '',
        inVesselCode: '',
        inVoyageNo: '',
        inVoyageLeg: '',
        arrivalDate: '',
        deliverableDate: ''
      },
      total: [],
      tableFeeData: []
    };
  },
  created: function created() {
    this.isCnLang = this.$i18n.locale === 'zh';
  },
  methods: {
    toMoney: _util.toMoney,
    validateNull: _validate.validateNull,
    /**
     *  费用合计
     **/
    getSummaries: function getSummaries(param) {
      var _this = this;
      var columns = param.columns,
        data = param.data;
      var sums = [];
      columns.forEach(function (column, index) {
        if (index === 3) {
          sums[index] = _this.$t('deliveryInfo.total');
          return;
        }
        if (index === 4) {
          sums[index] = (0, _util.toMoney)(_this.total.amount) + ' ' + _this.total.currency;
          return;
        }
      });
      return sums;
    },
    /**
     * 查询
     */
    toSearch: function toSearch() {
      var _this2 = this;
      this.$refs.form.validate(function (vaild) {
        if (vaild) {
          _this2.loading = (0, _utils.load)();
          _this2.resetData();
          (0, _delivery.deliverySearch)({
            blNo: _this2.form.blNo,
            containerNo: _this2.form.containerNo
          }).then(function (response) {
            if (!_this2.validateNull(response.data)) {
              var resultData = response.data;
              var resultBaseData = resultData.list[0];
              _this2.baseData.blNo = resultBaseData.blNo;
              _this2.baseData.inVesselCode = resultBaseData.inVesselCode;
              _this2.baseData.inVoyageNo = resultBaseData.inVoyageNo;
              _this2.baseData.inVoyageLeg = resultBaseData.inVoyageLeg;
              _this2.baseData.arrivalDate = resultBaseData.arrivalDate;
              _this2.baseData.deliverableDate = resultBaseData.deliverableDate;
              _this2.total = resultData.list3[0];
              _this2.tableFeeData = resultData.list2;
              _this2.isResult = true;
            }
          }).catch(function () {
            _this2.baseData = [];
            _this2.total = [];
            _this2.tableFeeData = [];
          }).finally(function () {
            _this2.loading.close();
          });
        }
      });
    },
    /**
     * 表格数据重置
     */
    resetData: function resetData() {
      this.baseData = {
        blNo: '',
        inVesselCode: '',
        inVoyageNo: '',
        inVoyageLeg: '',
        arrivalDate: '',
        deliverableDate: ''
      };
      this.tableFeeData = [];
      this.total = [];
    }
  }
};